import type { ChooseContact } from "@appchoose/contact";
import { contacts } from "@appchoose/contact";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const amDefaultContact = contacts.find(
  (contact) => contact.id === "abir",
)!;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const saleDefaultContact = contacts.find(
  (contact) => contact.id === "floriane",
)!;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const logisticsManagerDefaultContact = contacts.find(
  (contact) => contact.id === "hortense",
)!;

export const findContact = (
  contactName: string | undefined,
  defaultContact: ChooseContact,
) => {
  return (
    contacts.find((contact) => contact.id === contactName) ?? defaultContact
  );
};
